export default __webpack_public_path__ + "static/media/me1.a4fa0ccb.jpg";